import { ScoutCandidate } from '../../services/scout.service'

interface Props {
  candidate: ScoutCandidate
  onApprove: (id: number) => void
  onDismiss: (id: number) => void
  onBlacklist: (id: number) => void
  selected?: boolean
  onSelect?: (id: number) => void
}

function scoreColor(score: number) {
  if (score >= 80) return 'text-green-700 bg-green-50'
  if (score >= 60) return 'text-blue-700 bg-blue-50'
  if (score >= 40) return 'text-amber-700 bg-amber-50'
  return 'text-red-700 bg-red-50'
}

export default function CandidateCard({
  candidate,
  onApprove,
  onDismiss,
  onBlacklist,
  selected,
  onSelect,
}: Props) {
  const topics = candidate.ai_topics ? (JSON.parse(candidate.ai_topics) as string[]) : []

  return (
    <div className={`bg-white rounded-lg border p-4 ${selected ? 'ring-2 ring-primary-500' : ''}`}>
      <div className="flex items-start gap-3">
        {onSelect && (
          <input
            type="checkbox"
            checked={selected}
            onChange={() => onSelect(candidate.id)}
            className="mt-1 h-4 w-4 text-primary-600 rounded border-gray-300"
          />
        )}

        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <h4 className="font-semibold text-gray-900 truncate">{candidate.title}</h4>
            <span className={`px-2 py-0.5 text-xs font-medium rounded-full ${scoreColor(candidate.relevance_score)}`}>
              {candidate.relevance_score}%
            </span>
            {candidate.has_comments && (
              <span className="px-2 py-0.5 text-xs bg-purple-50 text-purple-700 rounded-full">
                comments
              </span>
            )}
            <span className="text-xs text-gray-400">
              {candidate.channel_type === 'group' ? 'Группа' : 'Канал'}
            </span>
          </div>

          <div className="flex items-center gap-3 text-sm text-gray-500 mb-2">
            {candidate.username && <span>@{candidate.username}</span>}
            {candidate.members_count != null && (
              <span>{candidate.members_count.toLocaleString()} подп.</span>
            )}
          </div>

          {candidate.description && (
            <p className="text-sm text-gray-600 mb-2 line-clamp-2">{candidate.description}</p>
          )}

          {candidate.ai_reason && (
            <p className="text-sm text-gray-500 italic mb-2">{candidate.ai_reason}</p>
          )}

          {topics.length > 0 && (
            <div className="flex flex-wrap gap-1 mb-3">
              {topics.map((t, i) => (
                <span key={i} className="px-2 py-0.5 bg-gray-100 text-gray-600 text-xs rounded-full">
                  {t}
                </span>
              ))}
            </div>
          )}

          {candidate.status === 'pending' && (
            <div className="flex items-center gap-2">
              <button
                onClick={() => onApprove(candidate.id)}
                className="px-3 py-1.5 bg-green-600 text-white text-sm rounded-lg hover:bg-green-700"
              >
                Добавить
              </button>
              <button
                onClick={() => onDismiss(candidate.id)}
                className="px-3 py-1.5 border border-gray-300 text-gray-700 text-sm rounded-lg hover:bg-gray-50"
              >
                Пропустить
              </button>
              <button
                onClick={() => onBlacklist(candidate.id)}
                className="px-3 py-1.5 text-red-600 text-sm hover:bg-red-50 rounded-lg"
              >
                Blacklist
              </button>
            </div>
          )}

          {candidate.status !== 'pending' && (
            <span className={`inline-block px-2 py-0.5 text-xs rounded-full ${
              candidate.status === 'approved' ? 'bg-green-100 text-green-700' :
              candidate.status === 'dismissed' ? 'bg-gray-100 text-gray-500' :
              'bg-red-100 text-red-700'
            }`}>
              {candidate.status === 'approved' ? 'Добавлен' :
               candidate.status === 'dismissed' ? 'Пропущен' : 'Blacklisted'}
            </span>
          )}
        </div>
      </div>
    </div>
  )
}
